<template>
  <custom-dialog class="protocol-add-param-dialog" width="1300px" :title="model.title" :visible="visible"
    v-on="$listeners" :append-to-body="true">
    <div class="dialog-body ub">
      <div class="ub-f1">
        <div class="title">{{ $t('dms_step_model_add_param_dialog.ji_chu_xin_xi') }}</div>
        <el-form :model="form" label-position="top" ref="form" :disabled="model.type === 'watch'">
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item :label="$t('dms_step_model_add_param_dialog.can_shu_ming_cheng')" prop="dataName" :rules="rules.dataName">
                <el-input v-model="form.dataName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('dms_step_model_add_param_dialog.can_shu_dai_ma')" prop="dataCode" :rules="rules.dataCode">
                <el-input v-model="form.dataCode"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item :label="$t('dms_step_model_add_param_dialog.duo_yu_yan_dai_ma')" prop="langTslName" :rules="rules.langTslName">
                <el-input v-model="form.langTslName" @input="langCodeChange" style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('dms_step_model_add_param_dialog.xian_shi_shun_xu')" prop="showOrder" :rules="rules.showOrder">
                <el-input :min="0" type="number" v-model="form.showOrder" style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item :label="$t('dms_step_model_add_param_dialog.ce_shi_bao_gao')" prop="isTestShow" :rules="rules.isTestShow">
                <el-radio-group v-model="form.isTestShow">
                  <el-radio :label="1">{{ $t('dms_step_model_add_param_dialog.ke_jian') }}</el-radio>
                  <el-radio :label="0">{{ $t('dms_step_model_add_param_dialog.bu_ke_jian') }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('dms_step_model_add_param_dialog.bjxqzt')" prop="isStatusShow"
                :rules="dataRules.isStatusShow">
                <el-radio-group v-model="dataForm.isStatusShow">
                  <el-radio :label="1">{{ $t('dms_step_model_add_param_dialog.ke_jian') }}</el-radio>
                  <el-radio :label="0">{{ $t('dms_step_model_add_param_dialog.bu_ke_jian') }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="24">
              <el-form-item :label="$t('dms_step_model_add_param_dialog.wu_mo_xing_miao_shu')" prop="tslDesc" :rules="rules.tslDesc">
                <el-input type="textarea" :rows="3" v-model="form.tslDesc" style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="width: 1px; background-color: #f2f3fb; margin: 0 24px"></div>
      <!-- 数据信息 -->
      <div class="ub-f1">
        <div class="title">{{ $t('dms_step_model_add_param_dialog.shu_ju_xin_xi') }}</div>
        <div class="param-form">
          <el-form :model="dataForm" label-position="top" ref="dataForm" :disabled="model.type === 'watch'">
            <el-form-item :label="$t('dms_step_model_add_param_dialog.kong_jian_lei_xing')" prop="widgetType" :rules="dataRules.widgetType">
              <div class="ub">
                <custom-select v-model="dataForm.widgetType" code="iot_tsl_widget_type" width="260px"
                  style="margin-right: 5px"></custom-select>
                <custom-select v-model="dataForm.isEditWidget" code="iot_tsl_widget_state"
                  :placeholder="$t('dms_step_model_add_param_dialog.kong_jian_zhuang_tai')" width="160px"></custom-select>
              </div>
            </el-form-item>

            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item :label="$t('dms_step_model_add_param_dialog.cun_chu_zi_duan_ming')" prop="dbField" :rules="dataRules.dbField">
                  <el-input v-model="dataForm.dbField" style="width: 100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('dms_step_model_add_param_dialog.cun_chu_lei_xing')" prop="dbType" :rules="dataRules.dbType">
                  <custom-select v-model="dataForm.dbType" code="iot_db_type" width="100%"></custom-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item :label="$t('dms_step_model_add_param_dialog.shu_ju_lei_xing')" prop="dataType" :rules="dataRules.dataType">
              <custom-select v-model="dataForm.dataType" code="iot_tsl_data_type" @change="onDataTypeChange" width="100%"
                :dataFilter="dataTypeFilter"></custom-select>
            </el-form-item>
            <!-- long/integer/double/big_decimal -->
            <div key="Long" v-if="dataForm.dataType === iotTslDataTypeObj.long ||
                          dataForm.dataType === iotTslDataTypeObj.integer ||
                          dataForm.dataType === iotTslDataTypeObj.double ||
                          dataForm.dataType === iotTslDataTypeObj.big_decimal
                          ">
              <el-form-item :label="$t('dms_step_model_add_param_dialog.shu_ju_fan_wei')" prop="min" :rules="dataRules.min">
                <el-input type="number" :placeholder="$t('dms_step_model_add_param_dialog.zui_xiao_zhi')" v-model="dataForm.min"
                  style="width: 100px"></el-input>
                <span style="margin: 0 16px">~</span>
                <el-input type="number" :placeholder="$t('dms_step_model_add_param_dialog.zui_da_zhi')" v-model="dataForm.max"
                  style="width: 100px"></el-input>
              </el-form-item>
              <el-row :gutter="20">
                <el-col :span="12" v-if="dataForm.dataType === iotTslDataTypeObj.big_decimal">
                  <el-form-item :label="$t('dms_step_model_add_param_dialog.shu_ju_chang_du')" prop="dataLen" :rules="dataRules.dataLen">
                    <el-input v-model="dataForm.dataLen" style="width: 100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('dms_step_model_add_param_dialog.mo_ren_zhi')" prop="defaultValue"
                    :rules="dataRules.defaultValue">
                    <el-input v-model="dataForm.defaultValue"></el-input>
                    <!-- <el-input-number v-model="dataForm.defaultValue"></el-input-number> -->
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item :label="$t('dms_step_model_add_param_dialog.cun_chu_bei_lv')" prop="dbRatio">
                    <el-input type="number" v-model="dataForm.dbRatio" :min="0"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('dms_step_model_add_param_dialog.cun_chu_dan_wei')" prop="dbUnit">
                    <custom-select v-model="dataForm.dbUnit" code="iot_tsl_data_unit"></custom-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item :label="$t('dms_step_model_add_param_dialog.xian_shi_bei_lv')" prop="showRatio">
                    <el-input type="number" v-model="dataForm.showRatio" :min="0"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('dms_step_model_add_param_dialog.xian_shi_dan_wei')" prop="showUnit">
                    <custom-select v-model="dataForm.showUnit" code="iot_tsl_data_unit"></custom-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <!-- enum / boolean -->
            <div key="enum"
              v-if="dataForm.dataType === iotTslDataTypeObj.enum || dataForm.dataType === iotTslDataTypeObj.boolean">
              <el-form-item :label="$t('dms_step_model_add_param_dialog.zi_dian_zhi')" prop="dicGroup" :rules="dataRules.dicGroup">
                <custom-select v-model="dataForm.dicGroup" code="iot_tsl_dic_group" width="100%"></custom-select>
              </el-form-item>
              <el-form-item v-if="dataForm.dataType === iotTslDataTypeObj.enum" :label="$t('dms_step_model_add_param_dialog.mo_ren_zhi')"
                prop="defaultValue" :rules="dataRules.defaultValue">
                <el-input type="number" :placeholder="$t('dms_step_model_add_param_dialog.mo_ren_zhi')" v-model="dataForm.defaultValue"
                  style="width: 100px"></el-input>
              </el-form-item>
            </div>
            <!-- string -->
            <div key="text" v-if="dataForm.dataType === iotTslDataTypeObj.string">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item :label="$t('dms_step_model_add_param_dialog.shu_ju_chang_du')" prop="dataLen" :rules="dataRules.dataLen">
                    <el-input type="number" v-model="dataForm.dataLen" style="width: 100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('dms_step_model_add_param_dialog.mo_ren_zhi')" prop="defaultValue"
                    :rules="dataRules.defaultValue">
                    <el-input v-model="dataForm.defaultValue" style="width: 100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <!-- map -->
            <div v-if="dataForm.dataType === iotTslDataTypeObj.map">
              <el-form-item :label="$t('dms_step_model_add_param_dialog.structdui_xiang')" prop="children" :rules="dataRules.children">
                <ul>
                  <li class="ub" v-for="(item, index) in dataForm.children" :key="index" style="margin-bottom: 6px">
                    <div style="width: 330px">
                      <el-input disabled :placeholder="$t('dms_step_model_add_param_dialog.can_shu_ming_chengo', [item.dataName])"
                        style="width: 330px"></el-input>
                    </div>
                    <div class="handle" v-if="model.type === 'watch'">
                      <span class="edit" @click="watchParam(item)">{{ $t('Common.com_detail') }}</span>
                    </div>
                    <div class="handle" v-else>
                      <span class="edit" @click="editParam(item)">{{ $t('Common.com_edit') }}</span>
                      <span @click="deleteParam(index)">{{ $t('Common.com_delete') }}</span>
                    </div>
                  </li>
                </ul>
                <el-button style="margin-left: -12px" type="text" icon="icon icon-add" @click="addParam()">&ensp;{{
                                  $t('dms_step_model_add_param_dialog.xin_zeng_can_shu') }}</el-button>
              </el-form-item>
            </div>
            <!-- list -->
            <div key="array" v-if="dataForm.dataType === iotTslDataTypeObj.list">
              <el-form-item :label="$t('dms_step_model_add_param_dialog.yuan_su_lei_xing')" prop="elemType" :rules="dataRules.elemType">
                <custom-select v-model="dataForm.elemType" code="iot_tsl_data_type3" width="100%"></custom-select>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
      <div style="width: 1px; background-color: #f2f3fb; margin: 0 24px"></div>
      <div class="ub-f1">
        <div class="title">{{ $t('dms_step_model_add_param_dialog.TCPxin_xi') }}</div>
        <div class="param-form">
          <el-form :model="tcpForm" label-position="top" ref="tcpForm" :disabled="model.type === 'watch'">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('dms_step_model_add_param_dialog.TCPdai_ma')" prop="tcpDataCode">
                  <el-input v-model="tcpForm.tcpDataCode"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('dms_step_model_add_param_dialog.lei_xing')" prop="tcpDataType">
                  <custom-select code="iot_tcp_data_type" v-model="tcpForm.tcpDataType"></custom-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('dms_step_model_add_param_dialog.TCPbei_lv')" prop="tcpDataRatio">
                  <el-input v-model="tcpForm.tcpDataRatio"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('dms_step_model_add_param_dialog.TCPdan_wei')" prop="tcpDataUnit">
                  <custom-select v-model="tcpForm.tcpDataUnit" code="iot_tsl_data_unit"></custom-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('dms_step_model_add_param_dialog.TCPchang_du')" prop="tcpDataLen">
                  <el-input v-model="tcpForm.tcpDataLen" type="number"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('dms_step_model_add_param_dialog.shu_ju_zhuan_huan')" prop="transferType">
                  <custom-select :key="'transferType' + dataForm.dataType" v-model="tcpForm.transferType"
                    code="iot_transfer_type" :clearable="false" @change="transferTypeChange(tcpForm)"
                    :dataFilter="dataFilter" :filterOptions="dataForm" ref="transferType"></custom-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('dms_step_model_add_param_dialog.zhbds')" prop="transferExpression">
                  <el-input v-if="tcpForm.transferType && showInput(Object.assign(dataForm, tcpForm, form))"
                    v-model="tcpForm.transferExpression"></el-input>
                  <el-button v-if="tcpForm.transferType && showSetting(Object.assign(dataForm, tcpForm, form))"
                    type="text" size="mini" @click="settingExpression(Object.assign(dataForm, tcpForm, form))">
                    {{ $t('Common.com_set') }}
                  </el-button>
                  <span
                    v-if="!showInput(Object.assign(dataForm, tcpForm, form)) && !showSetting(Object.assign(dataForm, tcpForm, form))">{{ $t('dms_step_model_add_param_dialog.wu') }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('dms_step_model_add_param_dialog.TCPmiao_shu')">
                  <el-input type="textarea" v-model="tcpForm.tcpDataDesc"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
    <expression-setting-dialog v-if="showExpression" @close="showExpression = false" :code="expressionCode"
      :expression="expression" :model="dialogModel2" @confirm="expressionConfirm"></expression-setting-dialog>
  </custom-dialog>
</template>

<script>
// import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import expressionSettingDialog from '@/pages/dms/product/children/expression_setting_dialog.vue';
import { getTransferRelation, getShowSettingConfig, getShowInputConfig, showRelativeModelConfig } from '@/pages/dms/product/children/utils';

export default {
  mixins: [dialogMixins],
  components: {
    expressionSettingDialog,
  },
  data() {
    return {
      iotTslDataTypeObj: {},
      selectRow: {},

      tslId: '',
      expressionCode: '',
      expression: '',
      showExpression: false,

      form: {
        tslId: '', // 编辑id
        protocolCode: '', // 产品code
        tslClass: '',
        tslType: '',
        componentCode: '',
        tslName: '',
        tslCode: '',
        // isCommon: 1,
        langTslName: '',
        showOrder: '',
        dataGroup: '',
        tslIcon: '',
        tslDesc: '',
        isTestShow: 0,
        dataName: '',
        dataCode: '',

        tslData: {},
      },
      dataForm: {
        isStatusShow: 0,
        tslDataId: '',
        dataCode: '',
        dataName: '',
        dbField: '',
        widgetType: null,
        isEditWidget: null,
        dbType: '',
        dataType: '',
        // int/float/double 特有
        unit: '',
        max: '',
        min: '',
        defaultValue: '', // +text
        // enum/bool
        dicGroup: '',
        // text
        dataLen: null,
        // array
        elemType: '',
        children: [],
        langDataName: '',
        // 存储倍率
        dbRatio: '',
        // 存储单位 dbUnit iot_tsl_data_unit
        dbUnit: '',

        // 显示倍率：
        showRatio: '',
        // 显示单位：showUnit iot_tsl_data_unit
        showUnit: '',
      },
      tcpForm: {
        // TCP代码
        tcpDataCode: '',
        // TCP类型
        tcpDataType: '',
        // TCP倍率
        tcpDataRatio: '',
        // TCP单位  iot_tsl_data_unit
        tcpDataUnit: '',
        // TCP长度
        tcpDataLen: '',
        // 数据转换
        transferType: '',
        // 转换表达式
        transferExpression: '',
        // TCP描述
        tcpDataDesc: '',
      },
      // 属性用
      dataRules: {
        dataType: [{ required: true, message: this.$t('dms_step_model_add_param_dialog.shu_ju_lei_xing') }],
      },
      dialogVisible: false,
      dialogModel: {},

      /** 无需转化： "0"  值到值："1" 倍率："2" 时间类型："3" 时间格式时分-数字 : "4"   */
      transferRelation: [],
      showInputConfig: {},
      showSettingConfig: {},

      dialogModel2: {},
    };
  },
  mounted() {
    this.form.protocolCode = this.protocolCode;
    this.getDictionary('iot_transfer_type_show,iot_transfer_expression_widget,iot_tsl_data_type', (data) => {
      const transferRelationDic = data.iot_transfer_type_show;
      this.transferRelation = getTransferRelation(transferRelationDic);
      this.showInputConfig = getShowInputConfig(data.iot_transfer_expression_widget);
      this.showSettingConfig = getShowSettingConfig(data.iot_transfer_expression_widget);
      this.iotTslDataTypeObj = this.$transformDicCode(data.iot_tsl_data_type);
      this.initDialog();
    });
  },

  computed: {
    rules() {
      return {
        dataName: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        dataCode: {
          required: true,
          message: this.$t('Common.com_required'),
        },
      };
    },
  },
  methods: {
    onDataTypeChange() {
      this.formatDataRules();
      this.tcpForm.transferType = '';
      this.tcpForm.transferExpression = '';
    },
    // 过滤掉map类型选项
    dataTypeFilter(list) {
      const blackList = ['map', 'Map', 'MAP'];
      return list.filter(item => !blackList.includes(item.name));
    },
    confirm() {
      this.$refs.form.validate((valid1) => {
        this.$refs.dataForm.validate((valid2) => {
          this.$refs.tcpForm.validate((valid3) => {
            if (valid1 && valid2 && valid3) {
              const emitData = {
                ...this.form,
                ...this.dataForm,
                ...this.tcpForm,
              };
              if (this.model.type === 'add') {
                emitData.customId = this.$genNonDuplicateID();
              }
              this.$emit(this.model.type, emitData);
              this.closeDialog();
            }
          });
        });
      });
    },

    expressionConfirm(expression) {
      this.tcpForm.transferExpression = expression;
    },
    settingExpression(row) {
      if (!this.dataForm.dicGroup) {
        this.$message({
          message: this.$t('dms_step_model_add_param_dialog.qxxzzdz'),
          type: 'warning',
        });
        return;
      }
      this.expressionCode = this.dataForm.dicGroup;
      this.expression = row.transferExpression;
      this.dialogModel2.title = this.$t('dms_step_model_add_param_dialog.zhi_dui_zhi_she_zhi');
      this.showExpression = true;
      this.tslId = row.tslId;
    },
    showInput(row) {
      return showRelativeModelConfig(row, this.showInputConfig);
    },
    showSetting(row) {
      return showRelativeModelConfig(row, this.showSettingConfig);
    },
    transferTypeChange(row) {
      row.transferExpression = '';
    },
    dataFilter(list) {
      const dataType = this.dataForm.dataType;
      const ret = [];
      const typeConfig = this.transferRelation.find(item => item.types.includes(dataType));
      const transferList = list;

      if (!typeConfig) {
        return ret;
      }
      transferList.forEach((item) => {
        if (typeConfig.values.includes(item.value)) {
          ret.push(item);
        }
      });
      return ret;
    },
    // 初始化
    initDialog: function () {
      if (this.model.type === 'add') {
        this.form.protocolCode = this.protocolCode;
        this.configRules();
      }
      if (this.model.type === 'edit' || this.model.type === 'watch' || this.model.type === 'copy') {
        this.selectRow = this.model.data;
        this.getEditData();
      }
    },
    // 物模型类型
    tslChange: function () {
      this.form.tslClass = '';
      this.form.tslType = '';
    },
    tslNameChange: function (value) {
      this.dataForm.dataName = value;
    },
    tslCodeChange: function (value) {
      this.dataForm.dataCode = value;
    },
    langCodeChange: function (value) {
      this.dataForm.langDataName = value;
    },
    // 配置验证规则
    configRules: function () {
      const tips = {
        tslClass: this.$t('dms_step_model_add_param_dialog.wu_mo_xing_lei_xing'),
        tslName: this.$t('dms_step_model_add_param_dialog.wmxmc'),
        tslCode: this.$t('dms_step_model_add_param_dialog.wu_mo_xing_dai_ma'),
        tslIcon: this.$t('dms_step_model_add_param_dialog.wu_mo_xing_tu_biao'),
        propertyType: this.$t('dms_step_model_add_param_dialog.shu_xing_lei_xing'),
        dataRw: this.$t('dms_step_model_add_param_dialog.shu_ju_quan_xian'),
        eventType: this.$t('dms_step_model_add_param_dialog.shi_jian_lei_xing'),
        serviceType: this.$t('dms_step_model_add_param_dialog.fu_wu_lei_xing'),
        callingMode: this.$t('dms_step_model_add_param_dialog.fwdyfs'),
      };
      this.rules = {
        tslClass: [{ required: true, message: tips.tslClass }],
        tslName: [{ required: true, message: tips.tslName }],
        tslCode: [{ required: true, message: tips.tslCode }],
        propertyType: [{ required: true, message: tips.propertyType }],
        dataRw: [{ required: true, message: tips.dataRw }],
      };
      this.dataRules.dicGroup = {};
      if (this.dataForm.dataType === this.iotTslDataTypeObj.enum || this.dataForm.dataType === this.iotTslDataTypeObj.boolean) {
        this.dataRules.dicGroup = [
          {
            required: true,
            message: this.$t('dms_step_model_add_param_dialog.zi_dian_zhi'),
          },
          { max: 100, message: this.$t('Common.com_rules_length_max', [100]), },
        ];
      }
    },
    // 数据信息类型选择清空和验证规则
    formatDataRules: function () {
      this.dataForm.unit = '';
      this.dataForm.max = '';
      this.dataForm.min = '';
      this.dataForm.defaultValue = ''; // +text
      // enum/bool
      this.dataForm.dicGroup = '';
      // text
      this.dataForm.dataLen = null;
      // array
      this.dataForm.elemType = '';
      // struct
      this.dataForm.children = [];
      // rule enum/bool
      this.dataRules.dicGroup = {};
      if (this.dataForm.dataType === this.iotTslDataTypeObj.enum || this.dataForm.dataType === this.iotTslDataTypeObj.boolean) {
        this.dataRules.dicGroup = [
          {
            required: true,
            message: this.$t('dms_step_model_add_param_dialog.zi_dian_zhi'),
          },
          { max: 100, message: this.$t('Common.com_rules_length_max', [100]), },
        ];
      }
    },
    // 获取编辑数据
    getEditData: function () {
      const data = this.model.data;
      this.$setFormatData(this.form, data);
      this.$setFormatData(this.dataForm, data);
      this.$setFormatData(this.tcpForm, data);

      this.dataForm.isStatusShow = this.dataForm.isStatusShow ? 1 : 0;

      this.configRules();
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // 参数排序
    compare: function (property, desc = true) {
      return function (a, b) {
        var value1 = a[property] ? Number.parseInt(a[property], 10) : 0;
        var value2 = b[property] ? Number.parseInt(b[property], 10) : 0;
        if (desc) {
          // 升序排列
          return value1 - value2;
        } else {
          // 降序排列
          return value2 - value1;
        }
      };
    },
  },
};
</script>

<style lang="scss">
.protocol-add-param-dialog {
  .ub-f1 .title {
    color: #35405b;
    font-size: 14px;
    margin-bottom: 18px;
    font-weight: bold;
  }
}
</style>
